import { calcDateTime, endOfDateTime, isSameDateTime, startOfDateTime } from '@occc-app/lib/date';

import { DateRangePreset, RangeType } from './date-range-selector.types';

const isLastNDaysRange = (n: number, startDate: Date, endDate: Date, includeToday = false) => {
  const now = new Date();
  const periodStartDate = calcDateTime(now, 'sub', n, 'day');
  const periodEndDate = calcDateTime(now, 'sub', includeToday ? 0 : 1, 'day');

  return (
    isSameDateTime(startDate, startOfDateTime(periodStartDate, 'day'), 'day') &&
    isSameDateTime(endDate, endOfDateTime(periodEndDate, 'day'), 'day')
  );
};

export const isTodayRange = (startDate: Date, endDate: Date) => {
  return isLastNDaysRange(0, startDate, endDate, true);
};

export const isYesterdayRange = (startDate: Date, endDate: Date) => {
  return isLastNDaysRange(1, startDate, endDate);
};

export const isLast7DaysRange = (startDate: Date, endDate: Date) => {
  return isLastNDaysRange(7, startDate, endDate);
};

export const isLast14DaysRange = (startDate: Date, endDate: Date) => {
  return isLastNDaysRange(14, startDate, endDate);
};

export const isLast30DaysRange = (startDate: Date, endDate: Date) => {
  return isLastNDaysRange(30, startDate, endDate);
};

export const isLast60DaysRange = (startDate: Date, endDate: Date) => {
  return isLastNDaysRange(60, startDate, endDate);
};

export const isLast90DaysRange = (startDate: Date, endDate: Date) => {
  return isLastNDaysRange(90, startDate, endDate);
};

export const isLast365DaysRange = (startDate: Date, endDate: Date) => {
  return isLastNDaysRange(365, startDate, endDate);
};

export const getDateRanges = (includeToday = false): Record<RangeType, DateRangePreset> => {
  const now = new Date();
  const yesterday = calcDateTime(now, 'sub', 1, 'day');
  const last7Start = calcDateTime(now, 'sub', 7, 'day');
  const last14Start = calcDateTime(now, 'sub', 14, 'day');
  const last30Start = calcDateTime(now, 'sub', 30, 'day');
  const last60Start = calcDateTime(now, 'sub', 60, 'day');
  const last90Start = calcDateTime(now, 'sub', 90, 'day');
  const last365Start = calcDateTime(now, 'sub', 365, 'day');
  const endDate = includeToday ? now : yesterday;

  return {
    today: {
      label: 'Today',
      value: 'today',
      startDate: startOfDateTime(now, 'day'),
      endDate: endOfDateTime(now, 'day'),
      isSelected: isTodayRange,
    },
    yesterday: {
      label: 'Yesterday',
      value: 'yesterday',
      startDate: startOfDateTime(yesterday, 'day'),
      endDate: endOfDateTime(endDate, 'day'),
      isSelected: isYesterdayRange,
    },
    last_7_days: {
      label: 'Last 7 Days',
      value: 'last_7_days',
      startDate: startOfDateTime(last7Start, 'day'),
      endDate: endOfDateTime(endDate, 'day'),
      isSelected: isLast7DaysRange,
    },
    last_14_days: {
      label: 'Last 14 Days',
      value: 'last_14_days',
      startDate: startOfDateTime(last14Start, 'day'),
      endDate: endOfDateTime(endDate, 'day'),
      isSelected: isLast14DaysRange,
    },
    last_30_days: {
      label: 'Last 30 Days',
      value: 'last_30_days',
      startDate: startOfDateTime(last30Start, 'day'),
      endDate: endOfDateTime(endDate, 'day'),
      isSelected: isLast30DaysRange,
    },
    last_60_days: {
      label: 'Last 60 Days',
      value: 'last_60_days',
      startDate: startOfDateTime(last60Start, 'day'),
      endDate: endOfDateTime(endDate, 'day'),
      isSelected: isLast60DaysRange,
    },
    last_90_days: {
      label: 'Last 90 Days',
      value: 'last_90_days',
      startDate: startOfDateTime(last90Start, 'day'),
      endDate: endOfDateTime(endDate, 'day'),
      isSelected: isLast90DaysRange,
    },
    last_365_days: {
      label: 'Last 365 Days',
      value: 'last_365_days',
      startDate: startOfDateTime(last365Start, 'day'),
      endDate: endOfDateTime(endDate, 'day'),
      isSelected: isLast365DaysRange,
    },
  };
};
